import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkResult", "resultFormat", "resultCheck", "resultFormatSelect", "promptForResultCheck"]

  connect() {
    this.toggleResultFields()
  }

  toggleResultFields() {
    const needCheck = this.checkResultTarget.checked
    
    if (needCheck) {
      this.resultFormatTarget.style.display = "block"
      this.resultCheckTarget.style.display = "block"
      this.togglePromptForResultCheck()
    } else {
      this.resultFormatTarget.style.display = "none"
      this.resultCheckTarget.style.display = "none"
    }
  }

  togglePromptForResultCheck() {
    if (this.hasResultFormatSelectTarget && this.hasPromptForResultCheckTarget) {
      const resultFormat = this.resultFormatSelectTarget.value
      
      if (resultFormat === "link") {
        this.promptForResultCheckTarget.style.display = "none"
      } else {
        this.promptForResultCheckTarget.style.display = "block"
      }
    }
  }
}
